module.exports = __webpack_public_path__ + "img/left-s-me.298032b.webp";